import Meta from "./Meta";

export default class ProductType {
  meta: Meta;
  key: string;
  value?: string;
  moreAboutThis: string;

  constructor(productType: any) {
    this.meta = productType.meta;
    this.key = productType.key;
    this.value = productType.value;
    this.moreAboutThis = productType.more_about_this;
  }
}
